module.exports = __webpack_public_path__ + "static/media/cover.ae4f1adf.png";